import React from 'react';
import { useParams } from 'react-router-dom';

/**
 * Remounts a søknad page when the draft id in the URL changes. React Router
 * keeps a route's element mounted across param changes, so without this,
 * going from one child's draft to another's would keep the first draft's
 * loaded state.
 */
export default function KeyedByDraftId({ children }) {
  const { draftId } = useParams();
  return <React.Fragment key={draftId}>{children}</React.Fragment>;
}
